/* global require:true */

require.context('../flowplayer_v7/skin/icons', true);
import '../flowplayer_v7/skin/skin.scss';
import initFlowplayer from '../flowplayer_v7/init.js';

document.addEventListener('DOMContentLoaded', () => {
  initFlowplayer();
});
